import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    root: {
        borderBottom: '2px solid #eee',
        padding: theme.spacing(2),
    },
    expanded: {
        backgroundColor: '#F8FAFF',
    },
    title: {
        color: '#081F4D',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: theme.typography.pxToRem(16),
        '&:hover': {
            color: theme.palette.primary.main,
        },
    },
    subtitle: {
        marginTop: theme.spacing(1),
    },
    sideContentWrapper: {
        justifyContent: 'space-between',
        [theme.breakpoints.up('md')]: {
            justifyContent: 'flex-end',
            gap: theme.spacing(4),
        },
    },
    date: {
        color: '#767B87',
    },
    buttonWrapper: {
        '& [data-reach-accordion-button]': {
            border: 'none !important',
            backgroundColor: 'transparent',
            display: 'flex',
        },
    },
    buttonText: {
        fontWeight: 700,
        color: theme.palette.primary.main,
        textTransform: 'uppercase',
    },
    buttonIconWrapper: {
        width: 20,
        height: 20,
        borderRadius: '50%',
        backgroundColor: theme.palette.primary.main,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: theme.spacing(1),
    },
    buttonIcon: {
        color: theme.palette.common.white,
        fontSize: theme.typography.pxToRem(16),
        transform: 'rotate(90deg)',
    },
    buttonIconUp: {
        transform: 'rotate(270deg)',
    },
}));
